import type {
  CompetitorServiceTarget,
  CustomerCompetitorService,
  CustomerCompetitorServiceCreateRequest,
  CustomerCompetitorServiceList,
  CustomerCompetitorServiceUpdateRequest,
} from '@shared/types/customer-competitor-service';
import { api } from './client';

/// 競合サービス API のベース URL を target (firm / lawyer) から組み立てる。
/// 事務所単位は `/api/firms/:firm_id/competitor-services`、 弁護士単位は
/// `/api/lawyers/:lawyer_id/competitor-services`。 backend は同じテーブル
/// `customer_competitor_services` を XOR (firm_id / lawyer_id) で扱う。
function basePath(target: CompetitorServiceTarget): string {
  if (target.kind === 'firm') {
    return `/api/firms/${encodeURIComponent(target.firmId)}/competitor-services`;
  }
  return `/api/lawyers/${encodeURIComponent(target.lawyerId)}/competitor-services`;
}

/// HTTP wrappers for the `customer_competitor_services` subresource, scoped
/// to either a firm or a lawyer.
export const customerCompetitorServicesApi = {
  list(target: CompetitorServiceTarget): Promise<CustomerCompetitorServiceList> {
    return api.get<CustomerCompetitorServiceList>(basePath(target));
  },

  create(
    target: CompetitorServiceTarget,
    body: CustomerCompetitorServiceCreateRequest,
  ): Promise<CustomerCompetitorService> {
    return api.post<CustomerCompetitorService>(basePath(target), body);
  },

  update(
    target: CompetitorServiceTarget,
    competitorId: string,
    body: CustomerCompetitorServiceUpdateRequest,
  ): Promise<CustomerCompetitorService> {
    return api.patch<CustomerCompetitorService>(
      `${basePath(target)}/${encodeURIComponent(competitorId)}`,
      body,
    );
  },

  delete(target: CompetitorServiceTarget, competitorId: string): Promise<void> {
    return api.delete(`${basePath(target)}/${encodeURIComponent(competitorId)}`);
  },
};
